import React, { useState } from "react";
import { Container, Title } from "./styled";
import Button from "../ReUsableComponents/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import { useDispatch, useSelector } from "react-redux";
import { cardDelete } from "../../../../Services/listService";
import BasePopover from "../ReUsableComponents/BasePopover";
import AvaliacaoPopover from "../Popovers/Avaliacao/AvaliacaoPopover";
import AvaliacaoPreliminarPopover from "../Popovers/AvaliacaoPreliminar/AvaliacaoPreliminarPopover";
import AvaliacaoFinalPopover from "../Popovers/AvaliacaoFinal/AvaliacaoFinalPopover";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button as MuiButton,
} from "@mui/material";

const Actions = () => {
  const dispatch = useDispatch();
  const card = useSelector((state) => state.card);
  const [activePopover, setActivePopover] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const popoverComponents = {
    avaliacao: AvaliacaoPopover,
    avaliacaoPreliminar: AvaliacaoPreliminarPopover,
    avaliacaoFinal: AvaliacaoFinalPopover,
  };

  const handlePopoverClose = () => setActivePopover(null);

  const renderPopover = (popoverKey, title, anchorElement) => {
    if (!anchorElement || !popoverComponents[popoverKey]) return null;

    const PopoverContent = popoverComponents[popoverKey];
    return (
      <BasePopover
        anchorElement={anchorElement}
        closeCallback={handlePopoverClose}
        title={title}
        contents={<PopoverContent closeCallback={handlePopoverClose} />}
      />
    );
  };

  const handleDelete = () => {
    cardDelete(card.listId, card.boardId, card.cardId, dispatch);
    setDeleteDialogOpen(false);
  };

  return (
    <Container>
      <Title>Ações</Title>

      {/* Botão de deletar */}
      <Button
        clickCallback={() => setDeleteDialogOpen(true)}
        title="Deletar"
        icon={<DeleteIcon fontSize="small" />}
      />

      {/* Diálogo de confirmação */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza de que deseja deletar este card? Essa ação não pode ser
            desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancelar
          </MuiButton>
          <MuiButton onClick={handleDelete} color="error" autoFocus>
            Confirmar
          </MuiButton>
        </DialogActions>
      </Dialog>
      {card.listTitle === "EM AVALIAÇÃO" &&
        card.complexidade !== "" &&
        card.relevancia !== "" && (
          <>
            {/* Botão de avaliação preliminar */}
            {/* <Button
              clickCallback={(event) =>
                setActivePopover({
                  key: "avaliacaoPreliminar",
                  anchor: event.currentTarget,
                })
              }
              title="Avaliação Preli."
              icon={<AssignmentTurnedInOutlinedIcon fontSize="small" />}
            />
            {renderPopover(
              "avaliacaoPreliminar",
              "Avaliação Preli.",
              activePopover?.key === "avaliacaoPreliminar"
                ? activePopover.anchor
                : null
            )} */}

            {/* Botão de avaliação */}
            <Button
              clickCallback={(event) =>
                setActivePopover({
                  key: "avaliacao",
                  anchor: event.currentTarget,
                })
              }
              title="Avaliação"
              icon={<AssignmentTurnedInOutlinedIcon fontSize="small" />}
            />
            {renderPopover(
              "avaliacao",
              "Avaliação",
              activePopover?.key === "avaliacao" ? activePopover.anchor : null
            )}

            {/* Botão de avaliação final */}
            {/* <Button
              clickCallback={(event) =>
                setActivePopover({
                  key: "avaliacaoFinal",
                  anchor: event.currentTarget,
                })
              }
              title="Avaliação Final"
              icon={<AssignmentTurnedInOutlinedIcon fontSize="small" />}
            />
            {renderPopover(
              "avaliacaoFinal",
              "Avaliação Final",
              activePopover?.key === "avaliacaoFinal"
                ? activePopover.anchor
                : null
            )} */}
          </>
        )}
    </Container>
  );
};

export default Actions;
